


































































































































































































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import $Api from '@api'
import { RepaymentPageRecord, PartRepaymentData } from '@/api/model/repayment'
import * as JMath from '@/utils/math'

@Component
export default class ManualFormComponent extends Vue {
    @Prop() private msg!: string

    @Prop() visible!: boolean

    calcLoading = false
    calcDaysLoading = false
    calculateData: any = []
    calculateDaysData: any = []
    unpaidData: PartRepaymentData[] = []

    factTime = ''

    remark = ''
    indexs = 1
    defaultCalculateData = {
        inputAmount: 0,
        calcAmount: 0,
        capitalAmount: 0,
        interestAmount: 0,
        penaltyAmount: 0,
        feesAmount: 0,
        overdueFee:0
    }
    defaultCalculateDaysData = {
        inputAmount: 0,
        calcAmount: 0,
        capitalAmount: 0,
        interestAmount: 0,
        penaltyAmount: 0,
        feesAmount: 0,
        overdueFee:0
    }
    @Emit('close')
    handleClose(): void {}

    @Emit('refresh')
    handleRefresh(): void {}

    fetchData({ lid, indexs, ...rest }: RepaymentPageRecord): void {
        this.factTime = ''
        this.calculateData = [{ lid, indexs, ...this.defaultCalculateData }]
        this.calculateDaysData = [{ lid, indexs, ...this.defaultCalculateDaysData }]
        this.indexs = indexs

        $Api.repaymentService.partRepaymentLoadData({ lid, indexs }).subscribe(data => {
            this.unpaidData = [data]
        })
    }

    onManualSubmit(): void {
        let { factTime } = this
        // const [calculateItem] = this.calculateData
        // const { lid, totalAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount } = this.convertCalculateData(calculateItem)
        const calculateItem  = this.totalCalculateDaysData()
        console.log(calculateItem)
        const { lid, totalAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee } = calculateItem
        const indexs = this.indexs
        const valid = this.validCalculateData(totalAmount)
        const overdueFeesAmount = overdueFee
        if (!valid) {
            return
        }

        MessageBox.confirm(
            translate('repayment.unpaid.substractDialog.onPartailPaidSubmit.confirm', { inputAmount: totalAmount }),
            translate('common.tip'),
            {
                confirmButtonText: translate('common.btn.confirm'),
                cancelButtonText: translate('common.btn.cancel')
            }
        )
            .then(() => {
                $Api.repaymentService
                    .submitRepaymentSubstract({
                        lid,
                        totalAmount,
                        capitalAmount,
                        interestAmount,
                        penaltyAmount,
                        feesAmount,
                        overdueFeesAmount,
                        remark: this.remark,
                        indexs: indexs
                    })
                    .subscribe(
                        data => {
                            Message.success(translate('repayment.unpaid.manualDialog.onPartialPaidSubmit.success') as string)
                            this.handleClose()
                            this.handleRefresh()
                        },
                        error => {
                            Message.error(error.message)
                        }
                    )
            })
            .catch(() => {})
    }

    calcManualRepaymentHandler(row: PartRepaymentData): void {
        const inputAmount = Number(row.inputAmount).toFixed(2)
        const valid = this.validCalculateData(+inputAmount)

        if (!valid) {
            return
        }

        this.calcLoading = true

        $Api.repaymentService
            .calcPartRepayment({
                lid: row.lid,
                indexs: row.indexs,
                paidAmount: Number(inputAmount)
            })
            .pipe(
                finalize(() => {
                    this.calcLoading = false
                })
            )
            .subscribe(
                data => {
                    const [calculateItem] = this.calculateData
                    this.calculateData = [Object.assign(calculateItem, data)]
                },
                error => {
                    Message.error(error.message)
                }
            )
    }
    calcDaysRepaymentHandler(row: PartRepaymentData): void {
        const inputAmount = Number(row.inputAmount)
        const valid = this.validCalculateData(+inputAmount)

        if (!valid) {
            return
        }

        this.calcDaysLoading = true

        $Api.repaymentService
            .calcDaysRepayment({
                lid: row.lid,
                indexs: row.indexs,
                days: Number(inputAmount)
            })
            .pipe(
                finalize(() => {
                    this.calcDaysLoading = false
                })
            )
            .subscribe(
                data => {
                    const [calculateItem] = this.calculateDaysData
                    this.calculateDaysData = [Object.assign(calculateItem, data)]
                },
                error => {
                    Message.error(error.message)
                }
            )        
    }
    onInputHandler({ target }: any, shouldCalcTotal: boolean) {
        // Keep two decimal places by RegExp
        target.value = target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null

        if (shouldCalcTotal) {
            const [calculateItem] = this.calculateData
            const { capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee } = this.convertCalculateData(calculateItem)
            const total = this.sum(capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee)
            calculateItem.calcAmount = this.fixedTwo(total)
        }
    }
    onInputHandlerDays({ target }: any, shouldCalcTotal: boolean) {
        // Keep two decimal places by RegExp
        target.value = target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null

        if (shouldCalcTotal) {
            const [calculateItem] = this.calculateDaysData
            const { capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee } = this.convertCalculateData(calculateItem)
            const total = this.sum(capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee)
            calculateItem.calcAmount = this.fixedTwo(total)
        }
    }
    convertCalculateData(calculateItem: any) {
        let { lid, inputAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount,overdueFee } = calculateItem

        const totalAmount = this.fixedTwo(inputAmount)
        capitalAmount = this.fixedTwo(capitalAmount)
        interestAmount = this.fixedTwo(interestAmount)
        penaltyAmount = this.fixedTwo(penaltyAmount)
        feesAmount = this.fixedTwo(feesAmount)
        overdueFee = this.fixedTwo(overdueFee)
        return {
            lid,
            totalAmount,
            capitalAmount,
            interestAmount,
            penaltyAmount,
            feesAmount,
            overdueFee
        } as { [key: string]: number }
    }
    totalCalculateDaysData() {
        const [calculateItem] = this.calculateData
        let {lid, inputAmount, capitalAmount, interestAmount, penaltyAmount, feesAmount, overdueFee} = calculateItem;
        
        const [calItem]  = this.calculateDaysData;

        let totalAmountTotal = Number(calItem.calcAmount) + Number(inputAmount);
        let totalCapitalAmount = Number(calItem.capitalAmount) + Number(capitalAmount);
        let totalInterestAmount = Number(calItem.interestAmount) + Number(interestAmount)
        let totalPenaltyAmount = Number(calItem.penaltyAmount) +  Number(penaltyAmount)
        let totalFeesAmount = Number(calItem.feesAmount) + Number(feesAmount)
        let totalOverdueFee = Number(calItem.overdueFee) + Number(overdueFee)
        const totalAmount = this.fixedTwo(totalAmountTotal)
        capitalAmount = this.fixedTwo(totalCapitalAmount)
        interestAmount = this.fixedTwo(totalInterestAmount)
        penaltyAmount = this.fixedTwo(totalPenaltyAmount)
        feesAmount = this.fixedTwo(totalFeesAmount)
        overdueFee = this.fixedTwo(totalOverdueFee)
        return {
            lid,
            totalAmount,
            capitalAmount,
            interestAmount,
            penaltyAmount,
            feesAmount,
            overdueFee
        } as { [key: string]: number }
    }
    validCalculateData(inputAmount: number): boolean {
        const isNumber = isNaN(inputAmount) === true
        const isNumberErroeMessage = translate('repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber') as string

        if (this.validator(isNumber, isNumberErroeMessage)) {
            return false
        }

        return true
    }

    // utils
    validator(bool: boolean, message?: string, type?: string): boolean {
        if (bool) {
            Message[type || 'error'](message as string)
            return true
        } else {
            return false
        }
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }

    sum(...args) {
        return args.reduce((acc, cur) => {
            acc += cur
            return acc
        }, 0)
    }

    fixedTwo = (num: number): number => {
        let val = JMath.floatMul(num, 100)
        val = JMath.floatDiv(val, 100)
        return val
    }
}
